import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Head, Main, Root, TopAppBar, TopAppBarSpacer } from './Shared';
import Spinner from './Spinner';
const AppLoading = () => {
    return (_jsxs(Root, { children: [_jsx(Head, { title: document.title }), _jsx(TopAppBar, {}), _jsxs(Main, { children: [_jsx(TopAppBarSpacer, {}), _jsx(Spinner, { loading: true })] })] }));
};
export default AppLoading;
